import { Component, OnInit } from '@angular/core';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { Router } from '@angular/router';
import { TrustScheduleModel } from '../../models/trust-schedule-model';
import { TrustDataService } from '../../services/trust-data-service/trust-data.service';
import { TrustAddressModel } from '../../models/trust-address';
import { HttpErrorResponse } from '../../../../node_modules/@angular/common/http';
import { MatSnackBar } from '../../../../node_modules/@angular/material';
import { LoggingService } from '../../services/logging-service/logging.service';
import { UserSessionService } from '../../services/user-session-service/user-session.service';
import { HomeCardModel } from '../../models/home-card-model';
import { HomeCardService } from '../../services/home-card-service/home-card.service';

@Component({
  selector: 'app-contact-view',
  templateUrl: './portal-contact-view.component.html',
  styleUrls: ['./portal-contact-view.component.css']
})
export class PortalContactViewComponent implements OnInit {

  private trustScheduleList: TrustScheduleModel[];
  private trustAddressModelList: TrustAddressModel[];
  contactCard: HomeCardModel;
  loaded: boolean;
  error: boolean;

  constructor(private shellUpdateService: ShellUpdateService,
    private appConfigService: AppConfigService, private router: Router, private trustDataService: TrustDataService,
    private snackBar: MatSnackBar, private loggingService: LoggingService,
    private userSession: UserSessionService, private homeCardService: HomeCardService) { }

  ngOnInit() {
    // Make sure the route being accessed is desirable (not user from admin, or admin from user. Redirect if required)
    this.userSession.checkRoute(this.router.url);

    this.contactCard = this.userSession.homeCards.find(x => x.CardName === 'Contact');

    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(
      this.appConfigService.ApplicationName, this.contactCard.Title, null, null));

    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, true, true, true));
    this.loggingService.log("Loading trust address", this.appConfigService.LogToConsole);
    this.trustDataService.getTrustAddresses().subscribe(response => {
      this.trustAddressModelList = response.json();
      this.loggingService.log("Loaded trust address", this.appConfigService.LogToConsole);
      this.trustDataService.getTrustSchedules().subscribe(result => {
        this.trustScheduleList = result.json();
        this.loggingService.log("Loaded trust schedules", this.appConfigService.LogToConsole);
        this.loaded = true;
      }, (error: HttpErrorResponse) => {
        this.handleError(error);
      });
    }, (error: HttpErrorResponse) => {
      this.handleError(error);
    })
  }

  handleError(error: HttpErrorResponse) {
    switch (error.status) {
      case 0:
        this.error = true;
        this.snackBar.open("Sorry, we can't do that. You appear to be offline.", "", { duration: 5000 });
        this.loggingService.log("Error - offline", this.appConfigService.LogToConsole);
        break;
      case 401:
        this.error = true;
        this.snackBar.open("Sorry, we can't do that. Your login has expired.", "", { duration: 5000 });
        this.loggingService.log("Error - login expired", this.appConfigService.LogToConsole);
        this.userSession.logout();
        break;
      case 500:
        this.error = true;
        this.snackBar.open("Sorry, we can't do that. Server error.", "", { duration: 5000 });
        this.loggingService.log("Error - Server error", this.appConfigService.LogToConsole);
      default:
        break;
    }
  }

  getAmPm(value: any) {
    switch (value) {
      case "0":
        return "am";
      case "1":
        return "pm";
      default:
        break;
    }
  }

  getDay(value: any) {
    switch (value) {
      case "1":
        return "Mon";
      case "2":
        return "Tue";
      case "3":
        return "Wed";
      case "4":
        return "Thr";
      case "5":
        return "Fri";
      case "6":
        return "Sat";
      case "7":
        return "Sun";

      default:
        break;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/views/portal-contact-view/portal-contact-view.component.ts